import { Component, OnInit,Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { ApiServiceService } from '../api-service.service';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'ngx-fileupload',
  templateUrl: './fileupload.component.html',
  styleUrls: ['./fileupload.component.scss']
})
export class FileuploadComponent implements OnInit {
  pdfFiles: any;

  constructor(private dialog:NbDialogRef<FileuploadComponent>,private api:ApiServiceService, private translate: TranslateService) { }
  @Input() data;

  validationError:any;
  pickedFileName:any;
  pickedImage:any;
  allFiles:any;
  imageFiles:any;
  progress = 0;
  status = 'success';
  imagePicked:boolean= false;
  selectedFile:any;
  pickedGallaryIndex:any;
  description:any;
  allowedType:any;
  label:any;
  dimentionCheck:boolean = false;
  pickedFile:any;
  isInvalid:boolean = false;
  selectedFileType:any;
  isFilePicked:boolean = false;
  maxFileSize:any=5*1024*1024; // Default 5MB
  ngOnInit(): void {
    this.getFiles();
    console.log('data',this.data);
    this.description=this.data.description??'';
    this.allowedType=this.data?.allowedType??'IMAGE';
    
    // Get maxFileSize from data if provided, otherwise use default 1MB
    if(this.data?.maxFileSize){
      this.maxFileSize = this.data.maxFileSize;
    }
    
    if(this.data.label){
      this.label=this.data.label;
    }
    else{
      this.label='No Label';
    }

    if(this.data.width && this.data.height){
      this.dimentionCheck = true;
      console.log('check Point',this.dimentionCheck);
      
    }

  }



  getFiles(){
    this.api.getUserFiles().subscribe((res:any)=>{
      console.log(res);
      this.allFiles=res['data'];
      this.imageFiles=this.allFiles.filter((file:any)=>file.type == 'IMAGE');
      this.pdfFiles=this.allFiles.filter((file:any)=>file.type == 'PDF');
    },
    (err)=>{
      console.log(err);
    }
    );

  }


  onSelectFile(event) {
    this.validationError = '';
    this.pickedFileName = '';
    this.pickedImage = '';
    this.isInvalid = false;
    if (event.target.files && event.target.files[0]) {
      this.pickedFileName = event.target.files[0].name;
      
       console.log(event.target.files[0].type);
         if(this.allowedType == 'IMAGE' && event.target.files[0].type != 'image/jpeg' && event.target.files[0].type != 'image/png'&& event.target.files[0].type != 'image/gif'){
          this.api.toastrError(this.translate.instant('fileUpload.errors.invalidTypeImage'),this.translate.instant('fileUpload.toasts.error'));
          this.validationError = this.translate.instant('fileUpload.errors.invalidTypeImage');
          this.isInvalid = true;
          
          return;
        }
        
        // Check file size
        const sizeCheck = this.checkFileSize(this.maxFileSize, event.target.files[0].size);
        if(!sizeCheck) {
          // Format file sizes - show KB if less than 1MB, otherwise MB
          const formatFileSize = (bytes: number): string => {
            if (bytes < 1024 * 1024) {
              return (bytes / 1024).toFixed(2) + ' KB';
            }
            return (bytes / (1024 * 1024)).toFixed(2) + ' MB';
          };
          
          const currentSizeFormatted = formatFileSize(event.target.files[0].size);
          const maxSizeFormatted = formatFileSize(this.maxFileSize);
          const errorMessage = `File size (${currentSizeFormatted}) exceeds the maximum allowed size (${maxSizeFormatted}). Please reduce the file size and try again.`;
          
          this.api.toastrError(errorMessage, this.translate.instant('fileUpload.toasts.error'));
          this.validationError = errorMessage;
          this.isInvalid = true;
          return;
        }
        
          //take image dimension
          if(event.target.files[0].type == 'image/jpeg' || event.target.files[0].type == 'image/png' || event.target.files[0].type == 'image/gif' && this.dimentionCheck){
            console.log('check Point image block entered');
            this.selectedFileType = 'image';
          const img = new Image();
          img.src = window.URL.createObjectURL(event.target.files[0]);
          img.onload = () => {
            const width = img.naturalWidth;
            const height = img.naturalHeight;
            window.URL.revokeObjectURL(img.src);
            console.log('check Point img dimention',width,height);
            
              let dimensionCheck = this.checkFileDimension(width,height,this.data.width,this.data.height);
              if(!dimensionCheck){
                this.api.toastrError(this.translate.instant('fileUpload.errors.invalidDimension', { width: this.data.width, height: this.data.height }), this.translate.instant('fileUpload.toasts.error'));
                this.validationError = this.translate.instant('fileUpload.errors.invalidDimension', { width: this.data.width, height: this.data.height });
                this.isInvalid = true;
                return;
              }
              if (!this.isInvalid) {                    
                console.log('invalid Point',this.isInvalid);                  
                console.log(event.target.files[0]);          
                const reader = new FileReader();          
                reader.readAsDataURL(event.target.files[0]);          
                reader.onload = (event: any) => {             
                    this.pickedImage = event.target.result;             
                    this.imagePicked = true; 
                    this.isFilePicked = true;                       
                }          
                this.upload(event.target.files[0]);         
            }      
            
          }
        }
        else if( event.target.files[0].type == 'image/jpeg' || event.target.files[0].type == 'image/png' || event.target.files[0].type == 'image/gif' && this.isInvalid === false){
         
          console.log('invalid Point',this.isInvalid);
          this.selectedFileType = 'image';
          console.log(event.target.files[0]);
          const reader = new FileReader();
          reader.readAsDataURL(event.target.files[0]);
          reader.onload = (event: any) => {
            this.pickedImage = event.target.result;
            this.imagePicked = true;
            this.isFilePicked = true;
            
          }
          this.upload(event.target.files[0]);
        }
        else if (event.target.files[0].type === 'application/pdf' && this.isInvalid === false) {
          this.selectedFileType = 'pdf';
          console.log('PDF file selected:', event.target.files[0].name);
          this.pickedFileName = event.target.files[0].name;
          this.pickedImage = null; // Clear any previous image data
          this.imagePicked = false; // PDFs are not considered images
          this.isFilePicked = true;
          this.upload(event.target.files[0]); // Directly upload the PDF file
        } 
        else {
          console.log('Unsupported file type:', event.target.files[0].type);
          // Handle invalid file types (optional)
          this.pickedImage = null;
          this.imagePicked = false;
        }



      }
  }



  upload(data){
    this.progress = 0;
    const formdata = new FormData();
    formdata.append('image', data);
    formdata.append('label', this.label);
        this.api.fileUploadS3(formdata).subscribe({
          next: (event: any) => {
            if (event?.type === 1 && event?.total) { // HttpEventType.UploadProgress
              const percent = Math.round((event.loaded / event.total) * 100);
              this.progress = percent;
              this.imagePicked = true;
            } else if (event?.body) {
              console.log("event.body :",event.body); // HttpResponse
              this.progress = 100;
              this.selectedFile = event.body?.data;
              this.api.toastrSuccess(this.translate.instant('fileUpload.toasts.uploadSuccess'), this.translate.instant('fileUpload.toasts.success'));
              // Hide the progress bar after a brief delay to show 100%
              setTimeout(() => {
                this.imagePicked = false;
              }, 400);
            }
          },
          error: (err) => {
            console.log(err);
            this.progress = 0;
            this.imagePicked = false;
          }
        })
       
  }

  cancel(){
    this.dialog.close({'status':false});
  }

  selectAndClose(){
    this.dialog.close({'status':true,'data':this.selectedFile});
  }


  changePickedImage(){
    this.pickedImage = '';
    this.pickedFileName = '';
    this.imagePicked = false;
    this.isFilePicked = false;
    this.selectedFile=null;
  }

  selectFromGallary(item:any,index){
    this.selectedFile = item;
    this.pickedGallaryIndex = index;
  }


  onTabChange(event){
    console.log(event);
    if(event.tabTitle == 'Upload'){
      this.pickedImage = '';
      this.pickedFileName = '';
      this.imagePicked = false;
      this.isFilePicked = false;
     this.selectedFile = null;
     this.validationError = '';
     this.selectedFileType = null;

    }
    else{
      this.selectedFile = null;
      this.pickedGallaryIndex = null;
      this.validationError = '';

    }
  }


  checkFileSize(maxsize,size){
    if(size > maxsize){
      return false;
    }
    else{
      return true;
    }
  }

  checkFileDimension(width,height,maxwidth,maxheight){
    if(width > maxwidth || height > maxheight){
      return false;
    }
    else{
      return true;
    }
  }

}
